<template>
  <div class="border-top text-start p-1 d-flex justify-content-between align-items-center product-document">
    <div class="block-info w-100">
      <div class="fs-8 text-gray-600" :class="required ? 'required' : ''">{{documentNameCodeByType(type)[1]}}</div>
      <template v-for="(info, key) in documents"
                :key="key">
        <div v-if="!info.file_name">
          <div v-if="!loader">
            <input :id="'docUpload-'+numberToField" type="file" class="file-upload" hidden v-on:change="onChange">
            <label :for="'docUpload-'+numberToField" class="fs-7 text-primary cursor-pointer">Добавить файл</label>
          </div>
          <div v-else-if="loader">
            <span class="fs-7 text-primary">Загрузка...</span>
          </div>
        </div>
        <div v-else class="d-flex justify-content-between">
          <span class="fs-7 text-gray-700">{{info.file_name}}</span>
          <span v-if="info.body" @click="deleteDocument(key)" class="delete-item"><i class="ki-outline ki-cross-square fs-3"></i></span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'ClientDocumentUploads',
  props: {
    type: {
      type: Number,
      default: 1
    },
    title: {
      type: String,
      default: null
    },
    iin: {
      type: String,
      default: null
    },
    ulid: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    kind: {
      type: Number,
      required: true
    },
    itemKey: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loader:       false,
      documents:    [
        {
          id:          null,
          policy_ulid: this.ulid,
          c_id:        null,
          global:      null,
          title:       this.title,
          iin:         this.iin,
          type_id:     this.documentNameCodeByType(this.type)[0],
          object:      this.type === 4 ? this.iin :this.documentNameCodeByType(this.type)[1],
          body:        null,
          file_name:   null,
        }
      ],
      errorMessage: null,
    }
  },
  emits: ['AddDocument', 'DeleteDocument'],
  computed: {
    numberToField() { return Math.random()}
  },
  methods: {
    onChange(e) {
      this.loader     = true;
      let file        = structuredClone(this.documents[this.documents.length - 1]);
      file.body       = e.target.files[0];
      file.file_name  = e.target.files[0].name
      axios.post('/api/document/upload', file, {headers: {'content-type': 'multipart/form-data'}})
          .then(res => {
            if (res.data.result) {
              this.$notifySuccess({message: 'Файл успешно загружен'})
              let info = this.documents.length ? this.documents[this.documents.length - 1] : this.emptyDocument();
              info.id        = res.data.data.id
              info.body      = e.target.files[0]
              info.file_name = e.target.files[0].name
              info.kind      = this.kind
              info.itemKey   = this.itemKey
              this.$emit('AddDocument', info);
            } else if (res.data.errors) {
              this.$notifyError(res.data)
            }
          }).catch((err) => {
            this.$notifyError(err)
          }).finally(() => this.loader = false);
    },
    documentNameCodeByType(type) {
      const data = {
        1: ['00001', 'Документ, удостоверяющий личность'],
        2: ['00028', 'Документ, водительское удостоверение'],
        3: ['00033', 'Документ, подтверждающий право на льготу'],
        4: ['00021', 'Технический паспорт транспортного средства'],
      }
      return data[type];
    },
    deleteDocument(key) {
      this.loader = true;
      axios.post('/api/document/delete', this.documents[key])
          .then(res => {
            if (res.data.result) {
              this.$notifySuccess({message: 'Файл успешно удален'})
              let info = structuredClone(this.documents[key])
              info.itemKey = this.itemKey
              this.documents.splice(key, 1);
              this.$emit('DeleteDocument', info);
            } else if (res.data.errors) {
              this.$notifyError(res.data)
            }
          }).catch((err) => {
            this.$notifyError(err)
      }).finally(() => this.loader = false);
    },
    emptyDocument() {
      return {
        id:          null,
        policy_ulid: this.ulid,
        c_id:        null,
        global:      null,
        title:       this.title,
        iin:         this.iin,
        type_id:     this.documentNameCodeByType(this.type)[0],
        object:      this.documentNameCodeByType(this.type)[1],
        body:        null,
        file_name:   null,
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(data) {
        if (data) {
          data.push(this.emptyDocument());
          this.documents = data
        }
      }
    }
  }
}
</script>

<style scoped>

</style>